export default __webpack_public_path__ + "static/Bildschirmfoto-2019-11-08-um-16.28.54-a3cd00ee2b2bb042a1242c2a713e5b57.jpg";